export const projectByIdSelector = (state: any) => state?.projectById || {};
